export const SET_USER = "SET_USER";
export const SET_COURSES = "SET_COURSES";
